import { DocumentDetails } from './DocumentDetails';

export class SettelementLetterDto {

    private documentType: string;
    public documents: DocumentDetails[];

    constructor(settelementLetterDocument: any) {

        this.documentType = settelementLetterDocument.documentType;
        this.documents = [];
        if(settelementLetterDocument.documents) {
            for (const doc of settelementLetterDocument.documents) {
                this.documents.push(new DocumentDetails(doc));
            }
        }
    }

    /**
     * Getter $documentType
     * @return {string}
     */
    public get $documentType(): string {
        return this.documentType;
    }

    /**
     * Getter $documents
     * @return {DocumentDetails[]}
     */
    public get $documents(): DocumentDetails[] {
        return this.documents;
    }

    /**
     * Setter $documentType
     * @param {string} value
     */
    public set $documentType(value: string) {
        this.documentType = value;
    }

    /**
     * Setter $documents
     * @param {DocumentDetails[]} value
     */
    public set $documents(value: DocumentDetails[]) {
        this.documents = value;
    }

    

}
